/* eslint-disable no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';
import { addCommas } from '@helper';
import { format } from 'date-fns';
import { isDesktop } from 'react-device-detect';
import { verifySign } from '@api';
import CertModal from './CertModal';
const ApplyModal = ({ rate, repayMentTotalAmt }) => {
    // 簽驗
    const [errMsg, setErrMsg] = useState('');
    const [certificateNumber, setCertificateNumber] = useState('');
    // const veriObj = {};
    let tempObj = {};
    const [veriObj, setVeriObj] = useState({});
    function sign_callback(obj) {
        // veriObj.signature = obj.signed;
        // veriObj.serial = obj.casno;
        // veriObj.data = idno + ',payoff';
        tempObj = {};
        tempObj.signature = obj.signed;
        tempObj.serial = obj.casno;
        tempObj.data = idno.trim() + ',payoff';
        setVeriObj(tempObj);
        setCertificateNumber(obj.casno);
    }
    // const sign_callback = obj => {
    //     // 設false才可再次執行
    //     setmtksign(false);
    //     // 開始驗章流程
    //     veriObj.signature = obj.signed;
    //     veriObj.serial = obj.casno;
    //     verifySignFunc(veriObj).then(() => {
    //         setIsVerifyComplete(true);
    //     });
    // };

    async function verifySignFunc(veriObj) {
        const res = await verifySign(veriObj);
        if (res.data.code === '0') {
            setCertificateNumber(veriObj.serial);
        } else {
            // todo modal res.data.message
        }
        return res;
    }
    // 簽驗結束
    const {
        PayOffStore: {
            repayMentPartInterest,
            applyDisabled,
            applyModalVisible,
            closeApplyModal,
            getApplyRepayment,
            updateData,
            getPayoffBusinessTime,
        },
        AuthStore: {
            account,
            debitDeliveryBankAccount,
            borrowingAmount,
            updateUserInfo,
            debitDeliveryAccountName,
            debitDeliveryBankAccountCode,
            accountType,
            idno,
        },
    } = useStore();
    useEffect(() => {
        if (applyModalVisible) {
            if (!signWeb) {
                // 測試機關閉簽驗
                setCertificateNumber('test');
            } else {
                // 打開先簽章
                if (!isDesktop) {
                    const signObj = {
                        cb: sign_callback,
                    };
                    signObj.idno = idno.trim();
                    signObj.tosign = idno.trim() + ',payoff';
                    // veriObj.data = idno + ',payoff';
                    // P1
                    signObj.method = 'P7';
                    // eslint-disable-next-line no-undef
                    mtklib.sign(signObj);
                } else {
                    // 判斷web還是ap?
                    console.log(!!window.chrome.webview);
                    const capiobj = getCGCAPIATLADPTObj();
                    if (capiobj !== undefined) {
                        console.log('載入成功 !');
                        if (capiobj.NeedUpdateInstaller()) {
                            // 檢查是否有新版本要版更
                            const msg =
                                '已有新版[簽章ServiSign]元件，請重新下載及手動安裝元件後，再重新執行網頁!';
                            setErrMsg(msg);
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                    } else {
                        console.log('載入失敗 !');
                        setErrMsg('全景程式載入失敗');
                        updateData('certModalVisible', true);
                        closeApplyModal();
                        return;
                    }
                    const iKeyUsage = 0;
                    const strCSP = '';
                    const iHashFlags = 0x04; // SHA256

                    const text = idno.trim() + ',payoff'; // 簽章原文
                    let SignDataPC = '';
                    const id1 = 'CN=TW' + idno.trim() + '1'; // 身分證號

                    const strSubject = id1 + '\nOU=PSCNET'; // 統一證券OU
                    const strIssuer = '';
                    const strPin = '';

                    const iFlags =
                        CGCAPI_FLAG_SELCERT_AUTO +
                        '|' +
                        CGCAPI_FLAG_SELCERT_CHECKVALID;

                    let min = 10000;

                    const t1 = new Date().getTime();

                    SignDataPC = capiobj.CAPISign(
                        text,
                        'MS950',
                        strSubject,
                        strIssuer,
                        strCSP,
                        '',
                        iFlags,
                        iHashFlags,
                        iKeyUsage
                    ); // strIssure, strCSP, iKeyUsage固定
                    const t2 = new Date().getTime();
                    if (t2 - t1 < min) min = t2 - t1;
                    const rtn = capiobj.GetErrorCode();

                    if (rtn !== 0) {
                        setErrMsg('簽章失敗!錯誤代碼:' + GetErrorMessage(rtn));
                        updateData('certModalVisible', true);
                        closeApplyModal();
                    } else {
                        // 簽章成功取憑證序號
                        const subject = 'CN=TW' + idno.trim() + '1\nOU=PSCNET';
                        const flag =
                            CGCAPI_FLAG_SELCERT_AUTO +
                            '|' +
                            CGCAPI_FLAG_SELCERT_CHECKVALID;
                        const cert = capiobj.CAPI_XGetUserCertificate(
                            '',
                            subject,
                            flag,
                            0,
                            ''
                        ); // provider, keyusage, 第五個欄位為固定值
                        let rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            setErrMsg('取得使用者憑證失敗' + rtn);
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                        // 憑證取得序號
                        const serial = capiobj.CAPICertGetSerialNumber(cert, 0);
                        rtn = capiobj.GetErrorCode();
                        if (rtn !== 0) {
                            setErrMsg(
                                '取得憑證序號失敗!錯誤代碼:' +
                                    GetErrorMessage(rtn)
                            );
                            updateData('certModalVisible', true);
                            closeApplyModal();
                            return;
                        }
                        tempObj = {};
                        tempObj.signature = SignDataPC;
                        tempObj.serial = serial;
                        tempObj.data = idno.trim() + ',payoff';
                        setVeriObj(tempObj);
                        setCertificateNumber(tempObj.serial);
                    }
                    // setCertificateNumber('web');
                }
            }
        }
    }, [applyModalVisible]);
    const [isClicked, setIsClicked] = useState(true);
    return (
        <>
            <Modal
                show={applyModalVisible}
                onHide={closeApplyModal}
                title={'確認還款資料'}
            >
                <form>
                    <div className="border-0">
                        <h4 className=" title fw-bolder mb-2">
                            請您確認以下申請資料
                        </h4>
                        <ul className="mob-rev apply-info scrol-opacity table-responsive d-flex flex-nowrap justify-content-between align-items-end text-center mb-4 p-2">
                            <li className=" px-1 pt-sm-0 pt-2 pb-1  ">
                                <h6 className="red fs-15 ds-fs-18">
                                    {format(new Date(), 'yyyy/MM/dd')}
                                </h6>
                                <small className="fs-12">還款日期</small>
                            </li>
                            <li className=" px-1 pt-sm-0 pt-2 pb-1  position-relative">
                                <h6 className="red">
                                    $
                                    <span>
                                        {/* {repayMentTotalAmt ===
                                    parseInt(borrowingAmount) +
                                        repayMentPartInterest
                                        ? repayMentPartInterest
                                        : repayMentPartInterest} */}
                                        {addCommas(repayMentPartInterest)}
                                    </span>
                                </h6>
                                <small className="fs-12">還款利息</small>
                            </li>
                            <li className=" px-1 pt-2   pt-sm-0 m-rate-bg">
                                <div className=" rate-bg  d-sm-inline-block pt-sm-2  px-sm-3    text-white rounded-3">
                                    <h6 className="fs-15">
                                        <span>
                                            {repayMentTotalAmt ===
                                            parseInt(borrowingAmount) +
                                                repayMentPartInterest
                                                ? 0
                                                : Math.floor(rate * 100) / 100}
                                        </span>
                                        %
                                    </h6>
                                    <small className="fs-12">
                                        試算還款後維持率
                                    </small>
                                </div>
                            </li>
                        </ul>
                        <div className="formbox row g-4 ">
                            <div className="col-12">
                                <label htmlFor=" " className="form-label">
                                    還款專戶
                                </label>
                                <li className=" position-relative ">
                                    <input
                                        type="text"
                                        className="form-control "
                                        value={debitDeliveryAccountName}
                                        disabled
                                    />
                                </li>
                            </div>
                            <div className="col-12 position-relative">
                                <label htmlFor=" " className="form-label">
                                    專戶帳號
                                    <p className="pos-alt text-white bg-secondary rounded-2 p-1 bg-opacity-75 lh-1">
                                        {accountType === 'G'
                                            ? '需自行匯款至此專屬帳戶'
                                            : '還款總金額將至分戶帳(虛擬帳號)中扣除'}
                                    </p>
                                </label>
                                <li>
                                    <input
                                        type="text"
                                        className="form-control "
                                        value={`${debitDeliveryBankAccountCode}-${debitDeliveryBankAccount}`}
                                        placeholder="請輸入還款帳號"
                                        disabled
                                    />
                                </li>
                            </div>
                            <div className="col-12">
                                <label htmlFor=" " className="form-label">
                                    還款總金額
                                </label>
                                <li className="red-num position-relative ">
                                    <span className="fw-bolder position-absolute">
                                        $
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control fw-bolder"
                                        value={addCommas(repayMentTotalAmt)}
                                        disabled
                                    />
                                </li>
                            </div>
                        </div>
                        <p className=" text-danger text-start  fs-12 mt-2">
                            還款結果請至借還款查詢，若您實際繳款金額與申請金額不符，視為還款失敗
                        </p>
                        <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                            <button
                                className="btn_cancel btn rounded-pill  text-sm-center"
                                type="button"
                                onClick={() => {
                                    closeApplyModal();
                                }}
                            >
                                修 改
                            </button>
                            <button
                                className=" btn_check btn rounded-pill text-white "
                                type="button"
                                disabled={applyDisabled}
                                onClick={async e => {
                                    e.preventDefault();
                                    if (!signWeb) {
                                        // 測試機關閉簽驗
                                        updateData(
                                            'certificateNumber',
                                            certificateNumber
                                        );
                                    } else {
                                        const verifyResult =
                                            await verifySignFunc(veriObj);
                                        updateData(
                                            'certificateNumber',
                                            certificateNumber
                                        );
                                        if (verifyResult.data.code !== '0') {
                                            setErrMsg(
                                                verifyResult.data.message
                                            );
                                            updateData(
                                                'certModalVisible',
                                                true
                                            );
                                            closeApplyModal();
                                            return;
                                        }
                                    }
                                    // 簽驗結束
                                    updateData('applyDisabled', true);
                                    const repaymentSwitch =
                                        await getPayoffBusinessTime();
                                    // if (isClicked) {
                                    //     setIsClicked(false);
                                    //     if (repaymentSwitch) {
                                    //         closeApplyModal();
                                    //         setTimeout(() => {
                                    //             setIsClicked(true);
                                    //         }, 3000);
                                    //         await getApplyRepayment(
                                    //             account,
                                    //             // accountType,
                                    //             debitDeliveryBankAccount,
                                    //             borrowingAmount
                                    //         );
                                    //         // updateUserInfo();
                                    //     } else {
                                    //         closeApplyModal();
                                    //     }
                                    // }
                                    if (repaymentSwitch) {
                                        closeApplyModal();
                                        await getApplyRepayment(
                                            account,
                                            // accountType,
                                            debitDeliveryBankAccount,
                                            borrowingAmount
                                        );
                                        updateUserInfo();
                                    } else {
                                        closeApplyModal();
                                    }
                                }}
                            >
                                確認申請
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>
            <CertModal msg={errMsg} />
        </>
    );
};

export default observer(ApplyModal);
